import { defineMessages } from "react-intl";

export default defineMessages({
  preview: {
    id: "preview",
    defaultMessage: "preview"
  },
});